export const SEARCH_LEDGER = 'SEARCH_LEDGER'
export const STORE_LEDGER_RESULT = 'STORE_LEDGER_RESULT'